import React from 'react';
import { contentProps } from './content.props';
import { DetailsContent } from '../../../api/club-cms/content';

export class AListContentComponent extends React.Component {
  static propTypes = {
    ...contentProps
  };

  state = {
    open: false,
    isNew: true,
    editInitialValues: {},
    editIem: null
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.node !== nextProps.node || this.state.open !== nextState.open
    );
  }

  createNewItem(data) {
    throw `Need to implement with this: ${data}`;
  }

  addItem(newItem) {
    const { node, onChange } = this.props;
    onChange(node.push(newItem));
  }

  updateItem(item, newItem) {
    const { node, onChange } = this.props;
    onChange(node.updateListItem(item, newItem));
  }

  deleteItem(item) {
    const { node, onChange } = this.props;
    onChange(node.remove(item));
  }

  showAdd() {
    this.setState({
      open: true,
      isNew: true,
      editInitialValues: {
        details: new DetailsContent()
      }
    });
  }

  saveProfile(data) {
    const { isNew, editIem } = this.state;
    if (!isNew) {
      this.updateItem(editIem, editIem.merge(data));
    } else {
      this.addItem(this.createNewItem(data));
    }
  }

  displayEditProfile(item) {
    this.setState({
      open: true,
      isNew: false,
      editIem: item,
      editInitialValues: Object.assign({}, { ...item })
    });
  }

  closeEditProfile() {
    this.setState({
      open: false,
      editInitialValues: {}
    });
  }

  render() {
    return <div>Need to implement</div>;
  }
}

export default AListContentComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/AbstractListComponent.js